/* unplugin-vue-components disabled */import { render } from "./UserName.vue?vue&type=template&id=1c24621e&scoped=true"
import script from "./UserName.vue?vue&type=script&lang=js"
export * from "./UserName.vue?vue&type=script&lang=js"

import "./UserName.vue?vue&type=style&index=0&id=1c24621e&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c24621e"]])

export default __exports__